import React from 'react';
import styled from 'styled-components';

const Footer = styled.footer`
  width: 100%;
  height: ;
`;

export default () => (
  <Footer>
    © 2018 bestrickst.de · Barbara Seeberger ·{' '}
    <a href="mailto:mail@bestrickst.de">Kontakt</a>
  </Footer>
);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js